import React, { useState } from 'react';
import { Link as Linker, useNavigate } from 'react-router-dom';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import axios from 'axios';
import logo from '../../assets/logo.png';
import { API_BASE_URL } from "../../config";

const Menu = ({ onClick, isMobile = false }) => {
  const linkClasses = isMobile 
    ? "text-white hover:text-[#54b3d6] transition-colors duration-300 no-underline text-lg py-2"
    : "text-white relative inline-block no-underline transition-all duration-300 ease-in-out menu-link";

  return (
    <>
      <Linker 
        to="/user-dashboard" 
        className={linkClasses}
        onClick={onClick}
      >
        Subject Dashboard
      </Linker>

      <Linker 
        to="/subjects" 
        className={linkClasses}
        onClick={onClick}
      >
        View Subjects
      </Linker>

      <Linker 
        to="/whats-new" 
        className={linkClasses}
        onClick={onClick}
      >
        What's New
      </Linker>
    </>
  );
};

const StudentNavbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.delete(`${API_BASE_URL}/api/logout`);
    } catch (err) {
      console.error("Logout failed", err);
    } finally {
      localStorage.removeItem("user");
      localStorage.removeItem("auth_token");
      delete axios.defaults.headers.common["Authorization"];
      navigate("/");
    }
  };

  const closeMenu = () => setToggleMenu(false);

  return (
    <nav className="w-full px-6 sm:px-8 lg:px-16 py-10">
      <div className="w-full flex items-center justify-between">
        
        {/* Logo - All the way left */}
        <Linker to="/" className="gap-2 flex items-center no-underline hover:opacity-90 transition-opacity flex-shrink-0">
        <div className="h-14 w-14 rounded-full flex items-center justify-center backdrop-blur-sm" 
          style={{
            background: 'rgba(255, 255, 255, 0.1)',
            boxShadow: '0 8px 32px 0 rgba(84, 179, 214, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.1)',
          }}
        >
          <img 
            src={logo} 
            alt="EduBahamas logo" 
            className="h-10 w-10 object-contain"
          />
        </div>
          <h1 className="text-white text-2xl sm:text-3xl font-bold m-0">EduBahamas</h1>
        </Linker>

        {/* Desktop Menu - Centered */}
        <div className="hidden md:flex items-center gap-10 flex-1 justify-center">
          <Menu />
        </div>

        {/* Desktop Sign Out Button - All the way right */}
        <div className="hidden md:block flex-shrink-0">
          <button 
            onClick={handleLogout} 
            className="bg-transparent hover:text-[#54b3d6] text-white px-4 py-2 rounded-md transition-all duration-300 ease-in font-normal text-sm border border-white/20 hover:border-[#54b3d6]/50"
            type="button"
          >
            Sign Out
          </button>
        </div>

        {/* Mobile Menu Icon */}
        <div className="md:hidden">
          {toggleMenu ? (
            <RiCloseLine 
              color="#fff" 
              size={27} 
              onClick={closeMenu} 
              className="cursor-pointer"
            />
          ) : (
            <RiMenu3Line 
              color="#fff" 
              size={27} 
              onClick={() => setToggleMenu(true)} 
              className="cursor-pointer"
            />
          )}
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {toggleMenu && (
        <div className="md:hidden mt-4 rounded-lg shadow-2xl p-6 absolute left-4 right-4 z-50 animate-scale-up bg-[#042c54]" style={{
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div className="flex flex-col gap-4" onClick={closeMenu}>
            <Menu onClick={closeMenu} isMobile={true} />
            <button 
              onClick={() => {
                closeMenu();
                handleLogout();
              }} 
              className="bg-transparent hover:text-[#54b3d6] text-white px-6 py-2.5 rounded-md transition-all duration-300 ease-in font-normal w-full mt-2 border border-white/20 hover:border-[#54b3d6]/50"
              type="button"
            >
              Sign Out
            </button>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes scale-up {
          0% {
            transform: scale(0.5);
            opacity: 0;
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }
        .animate-scale-up {
          animation: scale-up 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
        }

        /* Gradient text effect with underline animation */
        .menu-link {
          background-image: linear-gradient(to right, #54b3d6, #54b3d6 50%, #fff 50%);
          background-size: 200% 100%;
          background-position: -100%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          padding: 5px 0;
        }

        .menu-link::before {
          content: '';
          background: #54b3d6;
          display: block;
          position: absolute;
          bottom: -3px;
          left: 0;
          width: 0;
          height: 3px;
          transition: all 0.3s ease-in-out;
        }

        .menu-link:hover {
          background-position: 0;
        }

        .menu-link:hover::before {
          width: 100%;
        }
      `}</style>
    </nav>
  );
};

export default StudentNavbar;